import { FC, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Text } from '@chakra-ui/react';

import { truncateText } from '../../../../../utils/truncate-text';

import styles from '../EnhancedMessage.module.scss';
import inputStyles from './AssistantInput.module.scss';

interface AssistantInputProps {
    input: string;
}

export const AssistantInput: FC<AssistantInputProps> = ({ input }) => {
    const { t } = useTranslation('translations');
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const collapsedId = useId();

    const handleCollapse = () => setCollapsed((prev) => !prev);

    const textToShow = collapsed
        ? truncateText(input, {
              maxLength: 100,
              linesNumber: 3,
          })
        : input;

    const showCollapse = input !== textToShow || !collapsed;

    return (
        <AccordionItem borderColor="transparent">
            <Box className={styles.accordionHeader}>
                <AccordionButton>
                    <AccordionIcon />
                </AccordionButton>
                <Text className={styles.title}>{t('chat-tab.gathering-input')}</Text>
            </Box>

            <AccordionPanel>
                {textToShow}
                {showCollapse && (
                    <span id={collapsedId} className={inputStyles.collapse} onClick={handleCollapse}>
                        {collapsed ? t('answer.description.more') : t('answer.description.less')}
                    </span>
                )}
            </AccordionPanel>
        </AccordionItem>
    );
};
